const Projects = [
  {
    'file_count': 4,
    'project_id': 'Legal',
    'size': '1 MB',
    'user_id': 4
  },
  //  {
  //   'file_count': 5,
  //   'project_id': 'Construction',
  //   'size': '6 MB',
  //   'user_id': 4
  // },
  //  {
  //   'file_count': 4,
  //   'project_id': 'Accounting',
  //   'size': '1 MB',
  //   'user_id': 4
  // },
  //  {
  //   'file_count': 4,
  //   'project_id': 'Insurance',
  //   'size': '1 MB',
  //   'user_id': 4
  // },
  //  {
  //   'file_count': 5,
  //   'project_id': 'Retail',
  //   'size': '2 MB',
  //   'user_id': 4
  // }
]

export default Projects;